const colors = {
    'highlight': '#ff0059',
    'green': '#00E676',
    'blue': '#44a1ff',
}

export default colors;